import {useAuth} from "~/composables/auth/useAuth.js";

export default defineNuxtPlugin(async (nuxtApp) => {
    // init authentication service
    const { initAuth } = useAuth();
    await initAuth()
})